
export const INDEX = {
  CO_TYPE: {
    TRADE: 0,
    INVEST: 1,
  }
}
